import { TransactionTypeEnum } from '../../saved-searches/models/saved-search.static';
import { AccountModuleId, BillOrderModuleId, BillPaymentModuleId, EstimateOrderModuleId, InvoiceOrderModuleId, PurchaseOrderModuleId, SOModuleId, VendorCreditModuleId, VendorModuleId, VendorReturnModuleId } from './../../../modules/shared/constants/modules.constant';
import { WorkflowModelsNS } from "./add-update-workflow.models";

export const WorkflowMessages = {
    errorMessageSaveSearchName: 'Workflow Name Is Required',
    success: 'Success',
    saveSuccessMsg: 'Workflow saved successfully...',
    updateSuccessMsg: 'Workflow updated successfully...',
    updateErrorMsg: 'Error occurred while updating Workflow...',
    saveErrorMsg: 'Error occurred while saving Workflow...',
    detailsErrorMsg: 'Failed to load Workflow details...',
    updateearchaveErrorMsg: 'Error occurred while updating Workflow...',
    deleteconfirmationMessage: 'Do you want to delete this Workflow?',
    deleteHeader: 'Delete Confirmation',
    deleteCircleIcon: 'pi pi-info-circle',
    deleteSuccessMsg: 'Workflow Deleted successfully...',
    deleteErrorMsg: 'Error occured while deleting data...',
    error: 'Error',
    saveColSettngSuccessMsg: 'Workflow column settings updated successfully...',
    saveColSettngErrorMsg: 'Error occurred while updating column settings...',
    warning: 'Warn',
    noActionAdded: "Please add any action",
    noCondtionAdded: 'Please add any condtion',
    noRulesAdded: 'Please add any rules',
    clearRulesMessage: 'If you change this option, Your added conditions will be cleared!',
    rulesClearConfirmation: 'Want to Clear Conditions?',
    taskRunningSuccess: 'Workflow scheduler started successfully',
    taskRunNowSuccess: 'Workflow executed successfully',
    taskRunningFailed: 'Failed to run this workflow scheduler!',
    taskStopSuccess: 'Workflow scheduler stopped',
    taskStopFailed: 'Failed to run this workflow scheduler!',

} as const;

export const WorkflowActionTypeList = [
    {
        id: 0,
        name: 'All Actions Type'
    },
    {
        id: 1,
        name: 'Task'
    },
    {
        id: 2,
        name: 'Email Alert'
    },
    {
        id: 4,
        name: 'Update Field'
    },
    // {
    //     id: 4,
    //     name: 'Outbound Message'
    // },
    // {
    //     id: 5,
    //     name: 'SMS'
    // }
];

export const WorkflowActionNames = ['workflowActionTasks','workflowActionEmails','workflowActionCreateRecords','workflowActionDeleteRecords','workflowActionUpdateFields','workflowActionUpdateRecords','workflowActionConvertToInvoices'];

export const WorkflowExecutionStatusList = [
    {
        id: 0,
        name: 'All Execution Status'
    },
    {
        id: WorkflowModelsNS.WorkflowExecutionStatus.Executed,
        name: 'Executed'
    },
    {
        id: WorkflowModelsNS.WorkflowExecutionStatus.Executing,
        name: 'Executing'
    },
    {
        id: WorkflowModelsNS.WorkflowExecutionStatus.Pending,
        name: 'Pending'
    },
    {
        id: WorkflowModelsNS.WorkflowExecutionStatus.Failed,
        name: 'Failed'
    },
    {
        id: WorkflowModelsNS.WorkflowExecutionStatus.None,
        name: 'None'
    }
];

export const WorkflowActionModules = [
    {
        id: AccountModuleId,
        name: 'Account',
        objectId: AccountModuleId,
        parentModuleId: AccountModuleId,
        channelId: null,
        transactionId: null,
    },
    {
        id: VendorModuleId,
        name: 'Vendor',
        objectId: VendorModuleId,
        parentModuleId: VendorModuleId,
        channelId: null,
        transactionId: null,
    },
    {
        id: EstimateOrderModuleId,
        name: 'Estimate',
        objectId: EstimateOrderModuleId,
        parentModuleId: AccountModuleId,
        channelId: 1,
        transactionId: TransactionTypeEnum.Estimate
    },
    {
        id: InvoiceOrderModuleId,
        name: 'Invoice',
        objectId: InvoiceOrderModuleId,
        parentModuleId: AccountModuleId,
        channelId: 1,
        transactionId: TransactionTypeEnum.Invoice
    },
    {
        id: SOModuleId,
        name: 'SalesOrder',
        objectId: SOModuleId,
        parentModuleId: AccountModuleId,
        channelId: 1,
        transactionId: TransactionTypeEnum.SalesOrder
    },
    {
        id: PurchaseOrderModuleId,
        name: 'Purchase Order',
        objectId: PurchaseOrderModuleId,
        parentModuleId: VendorModuleId,
        channelId: 1,
        transactionId: TransactionTypeEnum.PurchaseOrder
    },
    {
        id: BillOrderModuleId,
        name: 'Bill Order',
        objectId: BillOrderModuleId,
        parentModuleId: VendorModuleId,
        channelId: 1,
        transactionId: TransactionTypeEnum.BillOrder
    },
    {
        id: VendorReturnModuleId,
        name: 'Vendor RMA',
        objectId: VendorReturnModuleId,
        parentModuleId: VendorModuleId,
        channelId: 1,
        transactionId: TransactionTypeEnum.VendorRMA
    },
    {
        id: VendorCreditModuleId,
        name: 'Vendor Credit',
        objectId: VendorCreditModuleId,
        parentModuleId: VendorModuleId,
        channelId: 1,
        transactionId: TransactionTypeEnum.VendorCredit
    },
    {
        id: BillPaymentModuleId,
        name: 'Bill Payment',
        objectId: BillPaymentModuleId,
        parentModuleId: VendorModuleId,
        channelId: 1,
        transactionId: TransactionTypeEnum.BillPayment
    }
];

export const WorkflowCurrentDateFields: any[] = [
    {
        labelname: 'Current Year',
        name: 'Current Year',
        field: 'currentYear',
        custom: true
    },
    {
        labelname: 'Current Month',
        name: 'Current Month',
        field: 'currentMonth',
        custom: true
    },
    {
        labelname: 'Current Week',
        name: 'Current Week',
        field: 'currentWeek',
        custom: true
    },
    {
        labelname: 'Current Day',
        name: 'Current Day',
        field: 'currentDay',
        custom: true
    }
];
